import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import Rebase from 're-base'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDM5ZisY0ms3wYy7ar4SJaNs4hQG0fpQeo",
  authDomain: "chat-s3morning.firebaseapp.com",
  databaseURL: "https://chat-s3morning.firebaseio.com",
  projectId: "chat-s3morning",
  storageBucket: "",
  messagingSenderId: "547577768553"
}

const app = firebase.initializeApp(config)

// Configure authentication
export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const githubProvider = new firebase.auth.GithubAuthProvider()

// Configure database
const db = firebase.database(app)
const base = Rebase.createClass(db)

export default base



// WEBPACK FOOTER //
// ./src/base.js